// Third party
import clsx from "clsx";

// MUI
import { Divider, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

// Components
import SimpleTextField from "@/Layouts/components/InputComponents/SimpleTextField";

// Helpers
import { and, or } from "@/Common/helpers/sonar";

// Types
import { IIntegrationProvider } from "@/Settings/types/administrationTools/model";

interface IAuthenticationFormProps {
	displayId: string;
	isFetching: boolean;
	approvalLinkInError: { hasError: boolean; message: string };
	payrollProvider: IIntegrationProvider | undefined;
	handleChangeDisplayId: (value: string) => void;
	handleRequestLink: () => void;
}

const AuthenticationForm = (props: IAuthenticationFormProps) => {
	const { displayId, isFetching, payrollProvider, approvalLinkInError, handleChangeDisplayId, handleRequestLink } = props;
	return (
		<Stack direction="column" mt={2}>
			<Stack direction="column" spacing={1}>
				<Typography className="!font-sans !font-normal !text-sm !text-default mb-1">New Authentication</Typography>
				<SimpleTextField
					editable
					outlined
					text={displayId}
					placeholder="Company Display ID"
					onChange={(value) => handleChangeDisplayId(value)}
					error={approvalLinkInError.hasError}
				/>
				<Typography
					className={clsx("!font-sans !font-normal !text-xs !text-error !text-center", {
						invisible: !approvalLinkInError.message,
						visible: approvalLinkInError.message,
					})}
				>
					{approvalLinkInError.message}
				</Typography>
			</Stack>
			<LoadingButton
				variant="contained"
				disableElevation
				onClick={handleRequestLink}
				disabled={or(approvalLinkInError.hasError, isFetching, !displayId)}
				loading={isFetching}
				fullWidth
				classes={{
					root: clsx("!mt-2 !h-[30px] !rounded-md !font-sans !text-sm !text-white !font-normal !normal-case", {
						"!bg-disabled !fill-white": or(approvalLinkInError.hasError, isFetching, !displayId),
						"!bg-primary": and(!approvalLinkInError.hasError, !isFetching, !!displayId),
					}),
					loadingIndicator: "!text-white",
				}}
			>
				{isFetching ? "" : "Request Client Access"}
			</LoadingButton>
			{payrollProvider?.configuredAccounts?.length ? (
				<>
					<Divider className="!mt-5 !mb-4" />
					<Stack direction={"column"} spacing={1}>
						<Typography className="!font-sans !font-normal !text-sm !underline !text-default">
							Current Authentications:
						</Typography>
						<Stack direction={"column"} spacing={0.7}>
							{payrollProvider?.configuredAccounts?.map((account, index) => {
								const keyIndex = `loggedAccount-${index}`;
								return (
									<Stack key={keyIndex} direction={"row"} spacing={0.5}>
										<Typography className="!text-xs !font-sans !font-bold !text-default">Company ID:</Typography>
										<Typography className="!text-xs !font-sans !font-normal !text-default">
											{account.displayId}
										</Typography>
									</Stack>
								);
							})}
						</Stack>
					</Stack>
				</>
			) : null}
		</Stack>
	);
};

export default AuthenticationForm;
